import InterestsSection from './InterestsSection'

export default InterestsSection
